import apiClient from "../configServices";
export default {
    postscore(id, session) {
        return apiClient.post('/intervention-plans/' + id + '/sessions', session)
    },
}

